import styled from 'styled-components';

export const Text = styled.p`
  ${({ theme }) => theme.fontSize.M16};
  cursor: pointer;
  margin-left: ${({ theme }) => `${theme.spacing.S8}`};
`;
